var $ = jQuery;

$(function() {
    // TR Menu - toggle
    $('[data-toggle-target]').on('click', function () {
        var target = $(this).attr('data-toggle-target');

        var el = $(`[data-toggle="${target}"]`);
        var collapsed = $(el).attr('data-collapse');
        if (collapsed == 'hidden') {
            el[0].style.setProperty('--collapse-height', `${el[0].scrollHeight}px`);
            $(el).attr('data-collapse', 'visible');
        } else {
            el[0].style.removeProperty('--collapse-height');
            $(el).attr('data-collapse', 'hidden');
        }
    });

    $("#js-trucker-resources")
        .on("mouseover", function() {
            var position = $("#js-trucker-resources-menu").css("position");

            if(position !== "static") {
                $("#js-trucker-resources-menu").removeClass("lg:hidden");
            }
        })
        .on( "mouseleave", function() {
            var position = $("#js-trucker-resources-menu").css("position");

            if(position !== "static") {
                $("#js-trucker-resources-menu").addClass("lg:hidden");
            }
        });
});
